<template>
  <div class="page-wrapper">
    <div style="width: 100%; height: 110px; background-color: #ccc;">
      <div class="container" style="padding-top:0; padding-bottom: 0; height: 120px;">
        <div class="row">
          <div class="col-6 pb-0">
            <select v-model="selectedDriverId" class="form-control" @change="onSelectorChanged">
              <option value="0">Driver</option>
              <option v-for="d in drivers" :value="d.id">{{d.name}}</option>
            </select>
          </div>
          <div class="col-6 pb-0">
            <input v-model="date" type="date" class="form-control" @change="onSelectorChanged"/>
          </div>
        </div>
        <div class="row">
<!--          <div class="col-3">-->
<!--            <div style="height: 38px; line-height: 38px; padding-left: 15px;">Shops</div>-->
<!--          </div>-->
          <div class="col-12">
            <select v-model="selectedMerchantId" class="form-control">
              <option value="0">All Shops</option>
              <template v-for="m in merchantList">
                <option v-bind:key="'merchant-selector-' + m.id" :value="m.id">{{m.title}}</option>
              </template>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; height: calc(100% - 60px); overflow-y: auto;">
      <v-container style="padding-bottom: 50px;">
        <v-list dense v-if="orders.length > 0" class="pa-0" style="display: none;">
          <v-card class="mb-5" style="padding:0;" v-for="order in orders" :key="'driver-order-' + order.id">
            <v-row class="pa-2 pending-job" v-bind:class="{'done-job':order.delivered == true}" no-gutters align="center"  v-on:click="getItem(order)">
              <v-col cols="8">
                <div class="h6">{{order.merchant.title}}</div>
                <div style="font-size: small;"><i class="fas fa-map-marker"> </i> {{order.merchant.address}}</div>
              </v-col>
              <v-col cols="4">
                <div class="h6 text-right">#{{order.id}}</div>
                <div class="h6 text-right" v-if="order.delivered == true">Delivered</div>
              </v-col>
            </v-row>

            <template v-for="item in order.list" >

              <v-row align="start" :key="item.id" no-gutters style="background-color: white; border-bottom: 1px solid gray;">
                <template v-if="item.state >= 0">
                  <v-col cols="1" class="pa-1 text-center">
                    <span style="font-size: 1.3rem;" v-if="item.driverChecked === true"><i class="fas fa-check" ></i></span>
                    <span style="font-size: 1.3rem;" v-if="item.driverChecked === false"><i class="fas fa-times" ></i></span>
                  </v-col>
                  <v-col cols="8" class="pa-1">
                    <div class="subtitle-2 py-0" v-text="item.title"/>
                    <div class="text-left caption" v-for="note in item.notes" :key="note.id" v-text="captionMemo(note)" />
                  </v-col>
                  <v-col cols="3" class="pa-1">
                    <div class="text-right font-weight-bold caption">
                      <span>{{item.amount}}</span>
                      <span v-if="item.useVariablePrice == true"><br>({{(item.variablePriceAmount/100.0).toFixed(1)}}kg)</span>
                    </div>
                    <!--                  <div class="text-right font-weight-bold caption">£{{(order.totalPrice / 100).toFixed(2)}}</div>-->
                    <!--                  <div class="text-right font-weight-bold caption">VAT: £{{(order.tax / 100).toFixed(2)}}</div>-->
                    <!--                  <div class="text-right font-weight-bold caption">Total: £{{(order.finalDue / 100).toFixed(2)}}</div>-->
                  </v-col>
                </template>
                <template v-else-if="item.state < 0">
                  <v-col cols="1" class="pa-1 text-center">
                    <span style="font-size: 1.3rem;"><i class="fas fa-check unchecked" v-bind:class="{'fa-check-circle checked': item.driverChecked == true}"></i></span>
                  </v-col>
                  <v-col cols="8">
                    <div class="subtitle-2 py-0">
                      <strike style="color:red;">
                        <span style="color:gray;">{{item.title}}</span>
                      </strike>
                    </div>
                    <div class="text-left caption" v-for="note in order.notes" :key="note.id" v-text="captionMemo(note)" />
                  </v-col>
                  <v-col cols="3" class="pa-1">
                    <div class="text-right font-weight-bold caption">{{item.amount}}</div>
                    <div class="text-right font-weight-bold caption" style="color:red;">Cancelled</div>
                  </v-col>
                </template>
              </v-row>

            </template>
          </v-card>
        </v-list>
        <div v-if="checkList != null && checkList.length > 0" >
          <div>


            <template v-for="(product, ii) in checkList" v-if="checkList.length >= 0">
              <v-container :key="'order-item-' + product.id + '-category-' + product.categoryId" v-if="ii === 0 || product.categoryTitle !== checkList[ii-1].categoryTitle"
                class="category-section">
                <v-row class="pa-0" >
                  <v-col cols="12" style="font-weight: bold; font-size: 30px;">{{product.categoryTitle}}</v-col>
                </v-row>
              </v-container>
              <v-container class="pt-0 pb-0" v-bind:key="'product-container-'+ product.id" style="margin-bottom: 20px; border: 1px solid #c4c4c4; border-radius: 10px; overflow: hidden;">

<!--                <v-row class="pa-1" :key="'order-item-' + product.id + '-category-' + product.categoryId" v-if="ii === 0 || product.categoryTitle !== checkList[ii-1].categoryTitle">-->
<!--                  <v-col cols="12" style="font-weight: bold; font-size: 20px;">{{product.categoryTitle}}</v-col>-->
<!--                </v-row>-->

                <v-row class="pa-1" style="background-color: #ededed;" v-if="parseInt(selectedMerchantId) === 0">
                  <v-col cols="10">
                    <strong>{{product.title}}</strong>
                  </v-col>
                  <v-col cols="2" class="text-center">
                    <strong>{{product.amount}}</strong>
                  </v-col>
                </v-row>
                <template v-for="item in product.list">

                  <v-row class="pa-1"
                         v-if="parseInt(selectedMerchantId) === 0 || item.merchantId === selectedMerchantId"
                         :key="'order-item-' + item.id"
                         v-bind:class="{'checked-item' : item.adminDriverChecked === true}"
                          style="border: 1px solid #e4e4e4;">
                    <v-col cols="2" class="pa-0 text-center">
                      <span style="font-size: 1.3rem;"><i class="fas fa-check unchecked" v-bind:class="{'fa-check-circle checked': item.adminDriverChecked === true}" @click="toggleAdminDriverCheck(item)"></i></span>
                    </v-col>
                    <v-col cols="2" class="pa-0 text-center">
                      <span style="font-size: 1.3rem;"><i class="fas fa-truck unchecked" v-bind:class="{'fa-check-circle checked': item.driverChecked == true}"></i></span>
                    </v-col>
                    <v-col cols="6" class="pa-0">
                      <strong>{{getMerchantName(item.merchantId)}}</strong>
                      <br>
                      {{item.title}}
                      <template v-if="item.notes.length > 0">
                        <div v-for="note in item.notes" style="color:blue;">
                          {{note.userName}}: {{note.description}}
                        </div>
                      </template>
                      <div v-if="item.useVariablePrice === true && item.variablePriceAmount > 10000" style="font-weight: bold; color: red; font-size: 1.5rem;">
                        Please check weight!!!
                      </div>
                    </v-col>
                    <v-col cols="2" class="pa-0 text-center" >
                    <span>
                        x{{item.amount}}
                    </span>
                      <br>

                      <!--                <input  v-if="item.driverChecked == false" class="form-control text-center" type="number" v-model="item.variablePriceAmount" v-on:change="updateWeight(item)"/>-->
                      <span v-if="item.useVariablePrice == true" :class="{'warning-item': item.variablePriceAmount > 10000 }">{{item.variablePriceAmountFloat.toFixed(2)}}Kg</span>


                    </v-col>
                  </v-row>
  <!--                <v-divider v-if="parseInt(selectedMerchantId) === 0 || item.merchantId === selectedMerchantId" class="mt-1 mb-1"></v-divider>-->
                </template>
              </v-container>

            </template>


<!--            <v-container style="position: sticky; bottom:0; background-color: white;">-->
<!--              <v-row>-->
<!--                <v-col cols="12">-->
<!--                  <button class="form-control btn btn-dark" v-on:click="closeCheckList">Close</button>-->
<!--                </v-col>-->

<!--              </v-row>-->
<!--            </v-container>-->
          </div>
        </div>
      </v-container>

    </div>
<!--    <transition name="slideup">-->
<!--      <div v-if="checkList != null && checkList.length > 0" style="z-index:3; position: absolute; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.7);" v-on:click="closeCheckList">-->
<!--        <div style="position: absolute; width: 90%; height: calc(100% - 150px); top:30px; left: 50%; transform: translateX(-50%); background-color: white; border-radius: 10px; overflow-y: scroll;" v-on:click.stop="dummy">-->

<!--          <v-container>-->
<!--            <template v-for="item in checkList" v-if="checkList.length >= 0">-->
<!--              <v-row class="pa-1" :key="'order-item-' + item.id">-->
<!--                <v-col cols="2" class="pa-0 text-center">-->
<!--                  <span style="font-size: 1.3rem;"><i class="fas fa-check unchecked" v-bind:class="{'fa-check-circle checked': item.adminDriverChecked === true}"></i></span>-->
<!--                </v-col>-->
<!--                <v-col cols="2" class="pa-0 text-center">-->
<!--                  <span style="font-size: 1.3rem;"><i class="fas fa-check unchecked" v-bind:class="{'fa-check-circle checked': item.driverChecked == true}"></i></span>-->
<!--                </v-col>-->
<!--                <v-col cols="6" class="pa-0">-->
<!--                  <strong>{{getMerchantName(item.merchantId)}}</strong>-->
<!--                  <br>-->
<!--                  {{item.title}}-->
<!--                  <template v-if="item.notes.length > 0">-->
<!--                    <div v-for="note in item.notes" style="color:blue;">-->
<!--                      {{note.userName}}: {{note.description}}-->
<!--                    </div>-->
<!--                  </template>-->
<!--                </v-col>-->
<!--                <v-col cols="2" class="pa-0 text-center" >-->
<!--                  <span>-->
<!--                      x{{item.amount}}-->
<!--                  </span>-->
<!--                  <br>-->

<!--                  &lt;!&ndash;                <input  v-if="item.driverChecked == false" class="form-control text-center" type="number" v-model="item.variablePriceAmount" v-on:change="updateWeight(item)"/>&ndash;&gt;-->
<!--                  <span v-if="item.useVariablePrice == true">{{item.variablePriceAmount}}Kg</span>-->


<!--                </v-col>-->
<!--              </v-row>-->
<!--              <v-divider class="mt-1 mb-1"></v-divider>-->
<!--            </template>-->

<!--          </v-container>-->
<!--          <v-container style="position: sticky; bottom:0; background-color: white;">-->
<!--            <v-row>-->
<!--              <v-col cols="12">-->
<!--                <button class="form-control btn btn-dark" v-on:click="closeCheckList">Close</button>-->
<!--              </v-col>-->

<!--            </v-row>-->
<!--          </v-container>-->
<!--        </div>-->
<!--      </div>-->
<!--    </transition>-->
    <div v-if="selectedDriverId > 0" style="position: absolute; bottom: 90px; right: 5px; width: 50px; height: 50px; line-height: 50px; font-size: 30px; text-align:center; background-color: #B3CEFF; color: black; border-radius: 20px; box-shadow: 3px 3px 5px gray;" @click="getOrderList">
      <span><i class="fas fa-sync"></i></span>
    </div>
  </div>
</template>

<script>
import {getDrivers, getDriverOrders, getDriverCategories} from "../api/drivers";
import {getAdminMerchants} from "../api/order";
import {millisToDate, showDialog} from "../api/utils";
import {changeAdminDriverChecked} from "../api/admin";

export default {
  name: "AdminDrivers",
  data() {
    return {
      drivers:[],
      orders:[],
      checkList:[],
      date:'',
      selectedDriverId: 0,
      merchants:[],
      selectedMerchantId:0,
      merchantList:[],
      categories:[],
    }
  },
  created() {
  },
  mounted() {
    this.$data.date = millisToDate(new Date().getTime(), '-');
    this.getCategoryList()
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {

    dummy: function() {

    },
    getCategoryList:function() {
      let self = this;
      getDriverCategories()
        .then(function(data) {
          if(data.success == true) {
            self.$data.categories = data.item;
            self.getDriverList();
          } else {
            showDialog(data.message, "No categories");
          }
        })
        .catch(function(err) {
          console.log(err);
          if(err.response != undefined) {
            console.log(err.response);
          }
        })
    },
    getDriverList: function() {
      let self = this;
      getDrivers()
      .then(function(data) {
        if(data.success === true) {
          data.item.sort(function(a, b){
            return a.name.localeCompare(b.name);
          })
          self.$data.drivers = data.item;
          self.getMerchantList();
        } else {
          showDialog(data.message);
        }
      })
      .catch(function(err) {
        showDialog("Something is wrong. Restart application or login again");
      })
    },
    getMerchantName: function(id) {
      if(id === 0) {
        return 'No Shop';
      }

      if(this.$data.merchants === null || this.$data.merchants.length === 0) {
        return 'No Shop List';
      }

      for(let i = 0 ; i < this.$data.merchants.length ; i++) {
        if(this.$data.merchants[i].id === id) {
          return this.$data.merchants[i].title;
        }
      }
      return 'Not found';
    },
    getMerchantList: function() {
      let self = this;
      getAdminMerchants()
      .then(function(data) {
        if(data.success === true) {
          self.$data.merchants = data.item;
          self.onLoaded();
        } else {
          showDialog("Could not get shop list");
        }
      })
      .catch(function(err) {
        let msg = err;
        if(err.response !== undefined) {
          msg += ' (' + err.response + ')';

        }
        showDialog(msg, "ERROR");
      })
    },
    onLoaded: function() {
      if(localStorage.getItem("selectedDriverId") !== null && localStorage.getItem("selectedDriverId") > 0) {
        this.$data.selectedDriverId = localStorage.getItem("selectedDriverId");
      }
      if(localStorage.getItem("selectedDriverDate") !== null && localStorage.getItem("selectedDriverDate").length === 10) {
        this.$data.date = localStorage.getItem("selectedDriverDate");
      }

      let today = millisToDate(new Date().getTime(), '-');
      if(this.$data.selectedDriverId === 0) {
        return;
      }

      if(this.$data.date === null || this.$data.date === '' || this.$data.date === '0000-00-00') {
        return;
      }
      if(this.$data.date !== today) {
        this.$data.date = today;
        localStorage.setItem("selectedDriverDate", today);
        return;
      }
      this.getOrderList();
    },
    onSelectorChanged: function() {
      localStorage.setItem("selectedDriverId", this.$data.selectedDriverId);

      if(this.$data.selectedDriverId === 0) {


        return;
      }

      if(this.$data.date === null || this.$data.date === '' || this.$data.date === '0000-00-00') {
        localStorage.removeItem("selectedDriverDate");
        return;
      }
      localStorage.setItem("selectedDriverDate", this.$data.date);
      this.getOrderList();
    },
    getOrderList: function() {
      if(this.$data.selectedDriverId === 0) {
        showDialog("Please select driver");
        return;
      }

      if(this.$data.date === null || this.$data.date === '' || this.$data.date === '0000-00-00') {
        showDialog("Please select date");
        return;
      }

      this.$data.orders = [];
      this.$data.checkList = [];
      this.$data.merchantList = [];
      let self = this;


      getDriverOrders(this.$data.selectedDriverId, this.$data.date)
      .then(function(data) {
        if(data.success === true) {
          self.$data.orders = data.item;
          self.setMerchantList();

        } else {

        }
      })
      .catch(function(err) {
        console.log(err);
        if(err.response !== undefined) {
          console.log(err);
        }
      })
    },
    setMerchantList: function() {

      this.$data.merchantList = [];

      for(let m = 0 ; m < this.$data.merchants.length ; m++) {
        for (let i = 0; i < this.$data.orders.length; i++) {
          if(this.$data.orders[i].merchantId === this.$data.merchants[m].id) {
            this.$data.merchantList.push(this.$data.merchants[m]);
            break;
          }
        }
      }
      this.populateCheckList();
    },
    closeCheckList: function() {
      this.$data.checkList = [];
    },
    populateCheckList: function() {
      let list = [];
      for(let i = 0 ; i < this.$data.orders.length ; i++) {
        for(let j = 0 ; j < this.$data.orders[i].list.length ; j++) {
          // console.log("populate check list " + i + " " + j);
          // if (this.$data.orders[i].list[j].useVariablePrice == true) {
          //   this.$data.orders[i].list[j].variablePriceAmount = (this.$data.orders[i].list[j].variablePriceAmount / 100.0).toFixed(2);
          // }

          list.push(this.$data.orders[i].list[j]);
        }
      }
      list.sort(function(a, b) {
        let titleA = a.title;
        let titleB = b.title;
        if(titleA.includes('] ')) {
          titleA = titleA.split('] ')[1];
        }
        if(titleB.includes('] ')) {
          titleB = titleB.split('] ')[1];
        }
        if(titleA < titleB) {
          return -1;
        } else if(titleA > titleB) {
          return 1;
        }
        return 0;
        // return a.productId - b.productId;
      })
      // list.sort(function(a, b) {
      //   if(a.categoryCode < b.categoryCode) {
      //     return -1;
      //   }
      //   if(a.categoryCode > b.categoryCode) {
      //     return 1;
      //   }
      //   return 0;
      // })
      // list.sort(function(a, b) {
      //   return a.productId - b.productId;
      // })

      let productId = 0;
      let productList = [];
      // let product = false;
      for(let i = 0 ; i < list.length ; i++) {

        let found = false;
        for(let p = 0 ; p < productList.length ; p++) {
          if(list[i].productId === productList[p].id) {
            found = true;
            break;
          }
        }
        if(found === false) {
          let product = {
            id: list[i].productId,
            amount: 0,
            title: list[i].title,
            list:[],
            categoryId: list[i].categoryId,
            categoryTitle: list[i].categoryTitle,
            categoryCode: list[i].categoryCode,
          }
          // console.log("product " + product.title + "[" + product.id + "] added");
          productList.push(product);
        }

        // if(productId !== list[i].productId) {
        //   productId = list[i].productId;
        //   let product = {
        //     id: productId,
        //     amount: 0,
        //     title: list[i].title,
        //     list:[],
        //     categoryId: list[i].categoryId,
        //     categoryTitle: list[i].categoryTitle,
        //     categoryCode: list[i].categoryCode,
        //   }
        //   console.log("product " + product.title + "[" + product.id + "] added");
        //   productList.push(product);
        //
        // }

      }

      for(let i = 0 ; i < productList.length ; i++) {
        for(let j = 0 ; j < list.length ; j++) {
          // console.log("compare p " + productList[i].id + " vs order " + list[j].productId);
          // console.log()
          if(list[j].productId === productList[i].id) {
            productList[i].amount += list[j].amount;
            productList[i].list.push(list[j]);
            console.log("product " + productList[i].title + " added " + list[j].amount);
          }
        }
      }
      productList.sort(function(a, b) {
        if(a.categoryCode < b.categoryCode) {
          return -1;
        }
        if(a.categoryCode > b.categoryCode) {
          return 1;
        }
        return 0;
      })
      // productList.sort(function(a, b) {
      //   return a.categoryId - b.categoryId;
      // })
      this.$data.checkList = productList;
      console.log(this.$data.checkList);
    },
    toggleAdminDriverCheck: function(item) {
      let self = this;

      if(item.useVariablePrice === true && item.variablePriceAmount > 10000) {
        showDialog("Please correct the weight. Weight cannot be greater than 100kg");
        return;
      }

      console.log("checked " + item.adminDriverChecked);
      changeAdminDriverChecked(item.id, !item.adminDriverChecked)
        .then(function(data) {
          if(data.success === true) {
            self.onItemChanged(data.item);
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    onItemChanged: function(item) {
      for(let i = 0 ; i < this.$data.checkList.length ; i++) {
        for(let j = 0 ; j < this.$data.checkList[i].list.length ; j++) {
          if (this.$data.checkList[i].list[j].id === item.id) {
            this.$data.checkList[i].list.splice(j, 1, item);
            return;
          }
        }
      }
    },
    getItem: function(id) {

    },
    captionMemo(note){
      return `${note.userName}: ${note.description}`
    },
  }
}
</script>

<style scoped>
.warning-item {
  background-color: #FFB3B3;
}
.checked-item {
  background-color: #B2F1B0;
}
.pending-job {
  background-color: #CCE8FF;

}
.done-job {
  background-color: #F1F1F1;
}
.unchecked {
  color: gray;
}
.checked {
  color: green;
}
.category-section {
  background: #FFB3B3;
  border-top: 10px solid #f00;
  padding-top:10px;
  padding-bottom: 10px;
  margin-top: 50px;
}
.warning-item {
  font-weight: bold;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/AdminDrivers.vue